import React from 'react';
import { CustomGridColumns } from '../../CustomDataGrid';

export const tributacaoSaidaColumns: CustomGridColumns[] = [
  {
    field: 'val_icms_sai_prod',
    headerName: 'Aliq. ICMS Saída',
    width: 130,
    format: 'Percentage',
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'tipo_tributacao_sai_prod',
    headerName: 'Tributação Saída',
    options: [
      { value: 0, label: 'Tributado' },
      { value: 1, label: 'Isento' },
      { value: 2, label: 'Redução' },
      { value: 3, label: 'Substituição' },
      { value: 4, label: 'Suspensão' },
      { value: 5, label: 'Diferido' },
      { value: 6, label: 'Outros ICMS' },
      { value: 7, label: 'Portaria CAT-38' },
      { value: 8, label: 'Não Tributado' },
    ],
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'val_red_bc_sai_prod',
    headerName: 'Red. BC Saída',
    width: 150,
    format: 'Percentage',
    sortable: false,
    disableColumnMenu: true,
  },
];
